import { render, staticRenderFns } from "./AgriculturalProducts.vue?vue&type=template&id=04459a03&scoped=true"
import script from "./AgriculturalProducts.vue?vue&type=script&lang=js"
export * from "./AgriculturalProducts.vue?vue&type=script&lang=js"
import style0 from "./AgriculturalProducts.vue?vue&type=style&index=0&id=04459a03&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04459a03",
  null
  
)

export default component.exports